var React = require('react');

function Tree (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.668 9.62396H13.748C14.558 9.62396 15.028 8.71397 14.568 8.05397L9.48801 0.803965C9.08801 0.233965 8.24801 0.233965 7.84801 0.803965L2.80801 8.05397C2.34801 8.71397 2.82801 9.62396 3.63801 9.62396H3.67801L0.778014 14.084C0.338014 14.744 0.818014 15.624 1.61801 15.624H6.69801V17.644C6.69801 18.734 7.58801 19.624 8.67801 19.624C9.76801 19.624 10.658 18.734 10.658 17.644V15.624H15.808C16.608 15.624 17.088 14.734 16.638 14.074L13.668 9.62396Z","fill":"#6C6C6C"}));
}

Tree.defaultProps = {"width":"17","height":"20","viewBox":"0 0 17 20","fill":"none"};

module.exports = Tree;

Tree.default = Tree;
